<div class="miangbdpg-boxxcont">
    <div class="col">
        <div class="p-3">
            <div>
                <h3>{{count}}</h3>
                <p>{{label}}</p>
            </div>
        </div>
    </div>
</div>